let locales = ['uk', 'en']
let mix_locales = (process.env.MIX_APP_LOCALES || '').split(',')
if (mix_locales.length) {
  locales = mix_locales.map(el => el.trim())
}

export const LANGUAGE_LIST = locales
export const DEFAULT_LANG = locales[0]
export const LANGUAGES_WITHOUT_DEFAULT = locales.filter(lang => lang !== DEFAULT_LANG)

export const GET_LOCALE_FIRST_PART = () => {
  return location.pathname.split('/').filter(Boolean).shift()
}

export const GET_LOCALE = () => {
  let path_locale = GET_LOCALE_FIRST_PART()
  if (!path_locale) return ''
  if (LANGUAGES_WITHOUT_DEFAULT.includes(path_locale)) {
    return path_locale
  }
  return ''
}

let curr_locale = DEFAULT_LANG
let location_locale = GET_LOCALE()
if (location_locale) {
  curr_locale = location_locale
}
export const CURRENT_LOCALE = curr_locale

